import { ChevronDownIcon, ChevronDownYellowIcon } from '@shared/components/Icons';
import clsx from 'clsx';
import { FC } from 'react';

type ChevronDownIconProps = {
  isActive: boolean,
  isVisible: boolean,
}

export const CategoryChevronDownIcon: FC<ChevronDownIconProps> = ({ isActive, isVisible }) => {
  const className = clsx('mr-4 transition-all duration-200', isVisible ? 'rotate-0' : 'rotate-180');

  return isActive ? <ChevronDownYellowIcon className={className} /> : <ChevronDownIcon className={className} />;
};
